<app-grid
  stateKey="UserRoles"
  gridCssClass="tab-grid-no-summary"
  [columnDefs]="columnDefs"
  [rowData]="rowData$ | async"
  [showDelete]="false"
  (save)="save()"
>
</app-grid>
